import { render, staticRenderFns } from "./tablesAtasan.vue?vue&type=template&id=7d66fc30&scoped=true"
import script from "./tablesAtasan.vue?vue&type=script&lang=js"
export * from "./tablesAtasan.vue?vue&type=script&lang=js"
import style0 from "./tablesAtasan.vue?vue&type=style&index=0&id=7d66fc30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d66fc30",
  null
  
)

export default component.exports